<template>
  <div class="agent-action-box">
    <!--渠道选择弹窗-->
    <el-dialog :title="'渠道选择'" :visible.sync="dialogVisible1" width="800px" :before-close="handleClose1" :close-on-click-modal="false" append-to-body>
      <div class="action-bar">
        <el-input size="small" placeholder="请输入渠道" style="width: 200px;" v-model="transParams.channel" clearable @keyup.enter.native="getNumberList('status')"></el-input>
        <el-button type="primary" size="small" class="checked" @click="getNumberList('status')">搜索</el-button>
      </div>
      <!-- <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" @selection-change="handleSelectionChange" @select="handleSelectionChange" ref="multipleTable"> -->
      <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" @select="handleSelectionChange" ref="multipleTable" :row-key="(row)=>row.id">
        <el-table-column type="selection" width="55" reserve-selection></el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel || '未知' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="device" label="设备" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.device || '未知' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-box" style="width:100%;height:70px">
        <el-pagination :page-sizes="[5]" :current-page="transParams.pageNumber" :page-size="transParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose1" size="small">取 消</el-button>
        <el-button type="primary" @click="checkedNumber()" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api';
export default {
  data() {
    return {
      // 内层弹出框
      dialogVisible1: false,
      // 内层弹窗表格加载状态
      loading: false,
      //  编辑是选中的渠道
      checkedChannel: [],
      selectedData: [],
      // 分页总条数
      total: 0,
      // 表格数据
      tableData: [],
      // 渠道input框绑定值
      channel: '',
      // 请求渠道列表参数
      transParams: {
        channel: '',
        pageNumber: 1,
        pageSize: 5,
      },
    };
  },
  methods: {
    // 打开表格选择弹窗
    open(data) {
      this.checkedChannel = data.split(',') || []
      this.dialogVisible1 = true;
      this.transParams.pageNumber = 1;
      this.getNumberList();
    },
    // 获取渠道列表
    getNumberList(type) {
      if (type === 'status') {
        this.transParams.pageNumber = 1;
      }
      this.loading = true;
      API.getNumberList(this.transParams)
        .then(res => {
          if (res.code === 200 && res.data.list.length > 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            /// 添加默认选项
            this.tableData.find(item => {
              if (this.checkedChannel.includes(item.channel)) {
                this.$refs.multipleTable.toggleRowSelection(item, true)
                this.checkedChannel.splice(this.checkedChannel.indexOf(item.channel), 1)
              }
            })
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.transParams.pageSize = size;
      this.transParams.pageNumber = 1;
      this.getNumberList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.transParams.pageNumber = pageNumber;
      this.getNumberList();
    },
    // 确认选中渠道
    checkedNumber() {
      if (!this.selectedData) {
        this.$message.error('请至少选择一个渠道！');
        return false;
      }
      this.handleClose1()
      let data = this.selectedData.map(res => res.channel).join(',')
      if (this.checkedChannel.length > 0) {
        data = data + ',' + this.checkedChannel.join(',')
      }
      this.$emit('onChange', data)
    },
    // 获取选中数据
    handleSelectionChange(selection) {
      this.selectedData = selection;
    },
    // 内侧弹窗关闭
    handleClose1() {
      this.$refs.multipleTable.clearSelection()
      this.transParams = {
        channel: '',
        pageNumber: 1,
        pageSize: 5,
      }
      this.dialogVisible1 = false;
    },
  }
};
</script>
<style lang="scss">
agent-action-box {
  .el-input {
    width: 220px;
  }
  .checked {
    margin-left: 10px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .page-box {
    margin-top: 35px;
    position: relative;
    height: 40px;
  }
  .el-pagination {
    margin-top: 0 !important;
  }
}
</style>
